import { apiSlice, ErrorType, errorTransform } from './api';
import { MeCollection } from '../swagger/collections-identity';
import { UserChangePasswordRequest } from '@ydistri/identity-sdk';
import { getTags } from './apiLib';

const { TAGS_ARRAY } = getTags('identity');

export const apiIdentity = apiSlice.enhanceEndpoints({ addTagTypes: TAGS_ARRAY }).injectEndpoints({
  endpoints: builder => ({
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- no response here
    updateUserPassword: builder.mutation<void, UserChangePasswordRequest>({
      queryFn: async payload => {
        try {
          const { data } = await MeCollection.changePassword(payload);
          return { data };
        } catch (error) {
          // Returned, not thrown: a thrown error is flattened to its message on the way to the
          // caller, and the form needs the problems inside response.data.
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- generated SDK error
          return { error: errorTransform(error as ErrorType) };
        }
      },
    }),
  }),
});

export const { useUpdateUserPasswordMutation } = apiIdentity;
